(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initHeaderMainMenu(){
    var $ = jQuery;
    $('.menu-item-has-children>a').click(function(){
        if(!$(this).parent().hasClass('is-menu-active') && $('body').hasClass('has-open-menu')){
            if(!$(this).parent().parent().parent().hasClass('is-menu-active')){
                $('.menu-item-has-children').removeClass('is-menu-active');
            }
            $(this).parent().addClass('is-menu-active');
            return false;
        }
    })
}